import { dateSort, getStatusColor } from "../../utils";
import { useEffect, useState } from "react";

import { ComponentPlaceholder } from "../../components/componentPlaceholder/componentPlaceholder";
import { ElementItem } from "../../missionMonitoringDashboard/components/mainList/mainList";
import LoadingImg from "../../components/loading";
import { MISSION_MONITORING_STATIC_STATUS } from "../../constants";
import PropTypes from "prop-types";
import { fetchAcquisitionReports } from "../../services/backendRequests";

// Single-site monitoring: the same expandable date rows as the monitoring page
// (ElementItem → MissionDetailsCard with its steps/flags timeline, flags panel
// and comment chat), so the campaign site view stays homogeneous with it.
export const SiteMonitoringPanel = ({
  missions,
  loading,
  user,
  refresh,
  siteId,
}) => {
  // Acquisition Report / HCC panel is driven by these rows (matched per
  // acquisition_date in MissionDetailsCard). The monitoring page fetches them
  // when a site row is expanded; here the panel IS the expanded site, so fetch
  // on mount.
  const [acquisitionReportResults, setAcquisitionReportResults] =
    useState(null);
  useEffect(() => {
    let unmounted = false;
    fetchAcquisitionReports(user, siteId)
      .then((results) => {
        if (!unmounted) setAcquisitionReportResults(results);
      })
      .catch(() => {});
    return () => {
      unmounted = true;
    };
  }, [user, siteId]);

  if (loading) return <LoadingImg visible />;

  if (missions.length === 0)
    return <ComponentPlaceholder text="No monitoring data for this site" />;

  const statusList = [
    ...new Set([
      ...MISSION_MONITORING_STATIC_STATUS,
      ...missions.map((mission) => mission.status),
    ]),
  ];
  const statusColor = (status) =>
    getStatusColor(statusList, status, [], undefined);

  const sorted = [...missions].sort((a, b) =>
    dateSort(a.acquisition_date, b.acquisition_date)
  );

  return (
    <div className="main-list">
      <div className="date-list collapse-list site-monitoring-list">
        {sorted.map((mission) => (
          <ElementItem
            key={mission.id}
            element={mission}
            getStatusColor={statusColor}
            refresh={refresh}
            user={user}
            acquisitionReportResults={acquisitionReportResults}
          />
        ))}
      </div>
    </div>
  );
};

SiteMonitoringPanel.propTypes = {
  missions: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  user: PropTypes.object.isRequired,
  refresh: PropTypes.func.isRequired,
  siteId: PropTypes.string.isRequired,
};
